module.exports = __webpack_public_path__ + "static/media/Work in Progress.eee30d7f.png";